import _ from 'lodash'

export const mergeByRecency = (sources, idKey = '_id') => {
  const freshestFirst = _.orderBy(sources, source => source.updatedAt ?? 0, 'desc')
  const allItems = _.flatten(freshestFirst.map(source => source.data ?? []))
  return _.uniqBy(allItems, idKey)
}
